export enum ELanguages {
  EN = 'en',
  RU = 'ru',
  UK = 'uk',
}
